import React from 'react';
import './LoadingPage.css';
import { useTranslation } from "react-i18next";

const LoadingPage = ({ message }) => {
  const { t } = useTranslation("notification");
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">{message || t("loading")}</p>
    </div>
  );
};

export default LoadingPage;